export default {
  de: {
    consentModal: {
      title: 'Cookies &amp; Tracking',
      description:
        'Wir verwenden Cookies und andere Speichertechnologien, um Ihnen das bestmögliche Web-Erlebnis zu bieten. Dies ermöglicht es uns auch, das Nutzerverhalten zu analysieren, um die Website für Sie ständig zu verbessern.',
      acceptAllBtn: 'Alle akzeptieren',
      acceptNecessaryBtn: 'Alle ablehnen',
      showPreferencesBtn: 'Einstellungen',
    },
    preferencesModal: {
      title: 'Cookie-Einstellungen',
      acceptAllBtn: 'Alle akzeptieren',
      acceptNecessaryBtn: 'Alle ablehnen',

      savePreferencesBtn: 'Einstellungen speichern',
      closeIconLabel: 'Schliessen',
      sections: [
        {
          title: 'Cookie Nutzung',
          description:
            'Wir verwenden Cookies, um die grundlegenden Funktionen der Website zu gewährleisten und um Ihr Online-Erlebnis zu verbessern. Sie können für jede Kategorie wählen, ob Sie sich ein- oder austragen möchten, wann immer Sie wollen. Weitere Einzelheiten zu Cookies und anderen sensiblen Daten finden Sie in der vollständigen <a href="/datenschutz" class="cc-link">Datenschutzrichtlinie</a>.',
        },
        {
          title: 'Notwendige Cookies',
          description:
            'Diese Cookies sind für das ordnungsgemässe Funktionieren der Website unerlässlich.',
          linkedCategory: 'necessary',
          cookieTable: {
            headers: {
              name: 'Name',
              description: 'Description',
            },
            body: [
              {
                name: 'Consent Cookie',
                description: 'Speichern der Cookieauswahl',
              },
              {
                name: 'Sprachauswahl',
                description: 'Speichern der Sprachauswahl',
              },
            ],
          },
        },
        {
          title: 'Funktionale Cookies',
          description:
            'Diese Cookies ermöglichen die erweiterte Nutzung der Webseite, wie das Laden von Videos welche über dritte Anbieter eingebunden werden oder das Absenden geschützter Formulare.',
          linkedCategory: 'functional',
        },
        {
          title: 'Analyse Cookies',
          description:
            'Statistik-Cookies helfen Website-Besitzern zu verstehen, wie Besucher mit Websites interagieren, indem sie Informationen sammeln und melden.',
          linkedCategory: 'analytics',
          cookieTable: {
            headers: {
              name: 'Name',
              description: 'Description',
            },
            body: [
              {
                name: 'Google Analytics',
                description: 'Cookies von Google Analytics',
              },
            ],
          },
        },
      ],
    },
  },
  fr: {
    consentModal: {
      title: 'Cookies &amp; Suivi',
      description:
        'Nous utilisons des cookies et d\'autres technologies de stockage pour vous offrir la meilleure expérience web possible. Cela nous permet également d\'analyser le comportement des utilisateurs afin d\'améliorer constamment le site pour vous.',
      acceptAllBtn: 'Tout accepter',
      acceptNecessaryBtn: 'Tout refuser',
      showPreferencesBtn: 'Paramètres',
    },
    preferencesModal: {
      title: 'Paramètres des cookies',
      acceptAllBtn: 'Tout accepter',
      acceptNecessaryBtn: 'Tout refuser',

      savePreferencesBtn: 'Enregistrer les paramètres',
      closeIconLabel: 'Fermer',
      sections: [
        {
          title: 'Utilisation des cookies',
          description:
            'Nous utilisons des cookies pour garantir les fonctionnalités de base du site Web et améliorer votre expérience en ligne. Vous pouvez choisir d\'activer ou de désactiver chaque catégorie à tout moment. Pour plus de détails sur les cookies et d\'autres données sensibles, consultez notre <a href="/datenschutz" class="cc-link">politique de confidentialité</a>.',
        },
        {
          title: 'Cookies nécessaires',
          description:
            'Ces cookies sont essentiels au bon fonctionnement du site Web.',
          linkedCategory: 'necessary',
          cookieTable: {
            headers: {
              name: 'Nom',
              description: 'Description',
            },
            body: [
              {
                name: 'Consent Cookie',
                description: 'Stocke les préférences de consentement',
              },
              {
                name: 'Préférence de langue',
                description: 'Stocke la sélection de la langue',
              },
            ],
          },
        },
        {
          title: 'Cookies fonctionnels',
          description:
            'Ces cookies permettent une utilisation avancée du site Web, comme le chargement de vidéos de fournisseurs tiers ou l\'envoi de formulaires protégés.',
          linkedCategory: 'functional',
        },
        {
          title: 'Cookies d\'analyse',
          description:
            'Les cookies statistiques aident les propriétaires de sites Web à comprendre comment les visiteurs interagissent avec les sites en collectant et en rapportant des informations.',
          linkedCategory: 'analytics',
          cookieTable: {
            headers: {
              name: 'Nom',
              description: 'Description',
            },
            body: [
              {
                name: 'Google Analytics',
                description: 'Cookies de Google Analytics',
              },
            ],
          },
        },
      ],
    },
  },
  it: {
    consentModal: {
      title: 'Cookie &amp; Tracciamento',
      description:
        'Utilizziamo cookie e altre tecnologie di archiviazione per offrirti la migliore esperienza web possibile. Questo ci permette anche di analizzare il comportamento degli utenti per migliorare costantemente il sito per te.',
      acceptAllBtn: 'Accetta tutti',
      acceptNecessaryBtn: 'Rifiuta tutti',
      showPreferencesBtn: 'Impostazioni',
    },
    preferencesModal: {
      title: 'Impostazioni dei cookie',
      acceptAllBtn: 'Accetta tutti',
      acceptNecessaryBtn: 'Rifiuta tutti',

      savePreferencesBtn: 'Salva impostazioni',
      closeIconLabel: 'Chiudi',
      sections: [
        {
          title: 'Utilizzo dei cookie',
          description:
            'Utilizziamo i cookie per garantire le funzionalità di base del sito web e migliorare la tua esperienza online. Puoi scegliere di attivare o disattivare ogni categoria in qualsiasi momento. Per maggiori dettagli sui cookie e altri dati sensibili, consulta la nostra <a href="/datenschutz" class="cc-link">informativa sulla privacy</a>.',
        },
        {
          title: 'Cookie necessari',
          description:
            'Questi cookie sono essenziali per il corretto funzionamento del sito web.',
          linkedCategory: 'necessary',
          cookieTable: {
            headers: {
              name: 'Nome',
              description: 'Descrizione',
            },
            body: [
              {
                name: 'Consent Cookie',
                description: 'Memorizza le preferenze di consenso',
              },
              {
                name: 'Preferenza lingua',
                description: 'Memorizza la selezione della lingua',
              },
            ],
          },
        },
        {
          title: 'Cookie funzionali',
          description:
            'Questi cookie permettono un utilizzo avanzato del sito web, come il caricamento di video da fornitori terzi o l\'invio di moduli protetti.',
          linkedCategory: 'functional',
        },
        {
          title: 'Cookie di analisi',
          description:
            'I cookie statistici aiutano i proprietari dei siti web a capire come i visitatori interagiscono con il sito raccogliendo e riportando informazioni.',
          linkedCategory: 'analytics',
          cookieTable: {
            headers: {
              name: 'Nome',
              description: 'Descrizione',
            },
            body: [
              {
                name: 'Google Analytics',
                description: 'Cookie di Google Analytics',
              },
            ],
          },
        },
      ],
    },
  },
  en: {
    consentModal: {
      title: 'Cookies & Tracking',
      description:
        'We use cookies and other storage technologies to provide you with the best possible web experience. This also allows us to analyze user behavior to continuously improve the website for you.',
      acceptAllBtn: 'Accept All',
      acceptNecessaryBtn: 'Reject All',
      showPreferencesBtn: 'Settings',
    },
    preferencesModal: {
      title: 'Cookie Settings',
      acceptAllBtn: 'Accept All',
      acceptNecessaryBtn: 'Reject All',

      savePreferencesBtn: 'Save Settings',
      closeIconLabel: 'Close',
      sections: [
        {
          title: 'Cookie Usage',
          description:
            'We use cookies to ensure the basic functions of the website and to improve your online experience. You can choose to opt in or out of each category whenever you like. For more details about cookies and other sensitive data, please see our full <a href="/datenschutz" class="cc-link">Privacy Policy</a>.',
        },
        {
          title: 'Necessary Cookies',
          description:
            'These cookies are essential for the proper functioning of the website.',
          linkedCategory: 'necessary',
          cookieTable: {
            headers: {
              name: 'Name',
              description: 'Description',
            },
            body: [
              {
                name: 'Consent Cookie',
                description: 'Stores cookie preferences',
              },
              {
                name: 'Language Preference',
                description: 'Stores the selected language',
              },
            ],
          },
        },
        {
          title: 'Functional Cookies',
          description:
            'These cookies enable advanced website features, such as loading videos from third-party providers or submitting protected forms.',
          linkedCategory: 'functional',
        },
        {
          title: 'Analytics Cookies',
          description:
            'Statistical cookies help website owners understand how visitors interact with the website by collecting and reporting information.',
          linkedCategory: 'analytics',
          cookieTable: {
            headers: {
              name: 'Name',
              description: 'Description',
            },
            body: [
              {
                name: 'Google Analytics',
                description: 'Cookies from Google Analytics',
              },
            ],
          },
        },
      ],
    },
  },
  sv: {
    consentModal: {
      title: 'Cookies & Spårning',
      description:
        'Vi använder cookies och annan lagringsteknik för att ge dig den bästa möjliga webbupplevelsen. Detta gör det också möjligt för oss att analysera användarbeteenden för att ständigt förbättra webbplatsen för dig.',
      acceptAllBtn: 'Acceptera alla',
      acceptNecessaryBtn: 'Avvisa alla',
      showPreferencesBtn: 'Inställningar',
    },
    preferencesModal: {
      title: 'Cookie-inställningar',
      acceptAllBtn: 'Acceptera alla',
      acceptNecessaryBtn: 'Avvisa alla',

      savePreferencesBtn: 'Spara inställningar',
      closeIconLabel: 'Stäng',
      sections: [
        {
          title: 'Användning av cookies',
          description:
            'Vi använder cookies för att säkerställa webbplatsens grundläggande funktioner och för att förbättra din onlineupplevelse. Du kan välja att aktivera eller avaktivera varje kategori när du vill. För mer information om cookies och annan känslig data, se vår fullständiga <a href="/datenschutz" class="cc-link">integritetspolicy</a>.',
        },
        {
          title: 'Nödvändiga cookies',
          description:
            'Dessa cookies är nödvändiga för att webbplatsen ska fungera korrekt.',
          linkedCategory: 'necessary',
          cookieTable: {
            headers: {
              name: 'Namn',
              description: 'Beskrivning',
            },
            body: [
              {
                name: 'Consent Cookie',
                description: 'Sparar cookie-inställningar',
              },
              {
                name: 'Språkinställning',
                description: 'Sparar valt språk',
              },
            ],
          },
        },
        {
          title: 'Funktionella cookies',
          description:
            'Dessa cookies möjliggör avancerade funktioner på webbplatsen, såsom att ladda videor från tredjepartsleverantörer eller skicka skyddade formulär.',
          linkedCategory: 'functional',
        },
        {
          title: 'Analyscookies',
          description:
            'Statistiska cookies hjälper webbplatsägare att förstå hur besökare interagerar med webbplatsen genom att samla in och rapportera information.',
          linkedCategory: 'analytics',
          cookieTable: {
            headers: {
              name: 'Namn',
              description: 'Beskrivning',
            },
            body: [
              {
                name: 'Google Analytics',
                description: 'Cookies från Google Analytics',
              },
            ],
          },
        },
      ],
    },
  },
  pl: {
    consentModal: {
      title: 'Ciasteczka & Śledzenie',
      description:
        'Używamy plików cookie i innych technologii przechowywania, aby zapewnić Ci jak najlepsze doświadczenia w sieci. Pozwala nam to również analizować zachowania użytkowników, aby stale ulepszać naszą stronę internetową.',
      acceptAllBtn: 'Akceptuj wszystkie',
      acceptNecessaryBtn: 'Odrzuć wszystkie',
      showPreferencesBtn: 'Ustawienia',
    },
    preferencesModal: {
      title: 'Ustawienia plików cookie',
      acceptAllBtn: 'Akceptuj wszystkie',
      acceptNecessaryBtn: 'Odrzuć wszystkie',

      savePreferencesBtn: 'Zapisz ustawienia',
      closeIconLabel: 'Zamknij',
      sections: [
        {
          title: 'Wykorzystanie plików cookie',
          description:
            'Używamy plików cookie, aby zapewnić podstawowe funkcje strony internetowej i poprawić Twoje doświadczenia online. Możesz w każdej chwili zdecydować, które kategorie chcesz włączyć lub wyłączyć. Więcej informacji o plikach cookie i innych wrażliwych danych znajdziesz w naszej <a href="/datenschutz" class="cc-link">Polityce prywatności</a>.',
        },
        {
          title: 'Niezbędne pliki cookie',
          description:
            'Te pliki cookie są niezbędne do prawidłowego funkcjonowania strony internetowej.',
          linkedCategory: 'necessary',
          cookieTable: {
            headers: {
              name: 'Nazwa',
              description: 'Opis',
            },
            body: [
              {
                name: 'Consent Cookie',
                description: 'Zapisywanie preferencji dotyczących plików cookie',
              },
              {
                name: 'Preferencje językowe',
                description: 'Zapisywanie wybranego języka',
              },
            ],
          },
        },
        {
          title: 'Funkcjonalne pliki cookie',
          description:
            'Te pliki cookie umożliwiają zaawansowane funkcje strony internetowej, takie jak ładowanie filmów z zewnętrznych źródeł lub przesyłanie chronionych formularzy.',
          linkedCategory: 'functional',
        },
        {
          title: 'Analityczne pliki cookie',
          description:
            'Pliki cookie statystyczne pomagają właścicielom stron internetowych zrozumieć, w jaki sposób użytkownicy wchodzą w interakcję ze stroną, poprzez zbieranie i raportowanie informacji.',
          linkedCategory: 'analytics',
          cookieTable: {
            headers: {
              name: 'Nazwa',
              description: 'Opis',
            },
            body: [
              {
                name: 'Google Analytics',
                description: 'Pliki cookie Google Analytics',
              },
            ],
          },
        },
      ],
    },
  },
}
